import { motion } from "framer-motion";
import F1 from "../assets/s11.png";
import F2 from "../assets/s22.png";
import F3 from "../assets/s33.png";
import F4 from "../assets/s44.png";

const NuestrosServicios = () => {

  const services = [
    {
      name: "Prestadora de Servicios",
      src: F1,
    },
    {
      name: "Consultoría en Gestión empresarial",
      src: F2,
    },
    {
      name: "Renta de Generadores de Ozono",
      src: F3,
    },
    {
      name: "Mantenimiento y Limpieza industrial",
      src: F4,
    },
  ];

  return (
    <div className="pt-12">
      <motion.h2
        className="text-sky-700 text-5xl text-center font-semibold mb-8"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        Nuestros servicios
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 md:px-12">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-xl overflow-hidden flex flex-col"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.3 }}
            viewport={{ once: true }}
          >
            <img
              src={service.src}
              alt={service.name}
              className="w-full h-32 object-contain"
            />

            <div className="p-4 flex flex-col flex-grow">
              <h3 className="text-slate-700 font-semibold text-lg mb-2 text-center ">
                {service.name}
              </h3>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default NuestrosServicios;
